<header
  class="flex h-16 flex-row items-center justify-between border-b border-surface-300
    bg-surface-50">
  <img
    alt="CXC Logo"
    src="logos/cxc_fullcolor.svg"
    class="ml-6 h-6 cursor-pointer"
    routerLink="/" />

  <div class="mr-6 flex flex-row gap-2">
    <notifications></notifications>

    <div
      class="selected flex h-11 w-auto cursor-pointer select-none flex-row items-center
        justify-start gap-2 rounded-md px-3"
      (click)="menu.toggle($event)">
      <div
        class="flex h-7 w-7 items-center justify-center rounded-full bg-secondary-700">
        <ng-icon
          name="phosphorUserBold"
          class="text-base !text-surface-100"></ng-icon>
      </div>

      <div class="flex grow flex-col">
        <small class="text-xs">
          {{ userStore.get().entity?.name }}
        </small>
        <small class="whitespace-nowrap text-xs text-surface-500">
          {{
            userStore.get().first_name + ' ' + userStore.get().last_name
              | titlecase
          }}
        </small>
      </div>
      <ng-icon name="phosphorCaretDown" class="text-sm"></ng-icon>
    </div>
  </div>
</header>

<p-menu
  #menu
  [model]="menuItems"
  [popup]="true"
  class="flex select-none justify-center"
  styleClass="w-full md:w-60 ">
  <ng-template #start>
    <div class="flex flex-col gap-1 py-2 pl-6 text-surface-500">
      <p class="font-semibold" i18n>Hello, {{ userStore.get().first_name }}!</p>
      <small class="break-words">{{ userStore.get().email }}</small>
    </div>
  </ng-template>
  <ng-template #submenuheader let-item>
    <span class="font-bold text-primary">{{ item.label }}</span>
  </ng-template>
  <ng-template #item let-item>
    <a
      pRipple
      class="p-menu-item-link flex items-center"
      (click)="item.action()">
      <ng-icon
        [name]="item.icon"
        class="text-xl {{ item.iconClass }}"></ng-icon>
      <span class="ml-2">{{ item.label }}</span>
    </a>
  </ng-template>
</p-menu>

<logout-dialog [(visible)]="showLogoutDialog"></logout-dialog>
